﻿import $ from "jquery";
import { FileAssetDto } from "./fileAssetDto";
import { EditableItemList, MovingDirection } from "./editableItemList";

// for layout 7
export class EditableUploadList extends EditableItemList<FileAssetDto> {
    private readonly emptyGuidString = "00000000-0000-0000-0000-000000000000";

    init(divElementId: string) {
        console.log("start initing editabelUploadList");
        this.itemList = $(`#${divElementId}`).data("initial");
        super.init(divElementId, "addUploadListButton");
        console.log(this.itemList);
    }

    protected drawItem(item: FileAssetDto, itemId: number) {
        // == is placed here on purpose for comparison of string.empty
        const pic = item.ImageId === this.emptyGuidString ? "" : `/fileasset/${item.ImageId}`;

        const itemElement = "<div class='box'>" +

            "<div class='field has-addons is-pulled-right'>" +
            "<p class='control'>" +
            "<button id='picUploadFieldRemove-" + itemId + "' class='button is-small' data-tooltip='Datei Entfernen'>" +
            "<span class='icon is-small'><i class='fas fa-times'></i></span>" +
            "</button>" +
            "</p>" +
            "</div>" +

            "<div class=\"panel-block\" >" +
            "<div class='control' data-tooltip='Dieses Bild kann im Html code eingefügt werden'>" +
            "<label class='label' >Bild hochladen</label>" +
            "<input type='hidden' name='EventToChange.FileAssets[" + itemId + "].ImageId' value='" + item.ImageId + "' />" +
            "<div class='file has-name is-fullwidth'>" +
            "<label class='file-label'>" +
            "<input id='listImageInput-" + itemId + "' class='file-input input' type='file' accept='pdf, pptx' name='EventToChange.FileAssets[" + itemId + "].ImageChanged'>" +
            "<span class='file-cta'>" +
            "<span class='file-icon'><i class='fas fa-upload'></i></span>" +
            "<span class='file-label'>Datei wählen</span>" +
            "</span>" +
            "<span id='listImageLabel-" + itemId + "' class='file-name'>Keine Datei ausgewählt</span>" +
            "</label>" +
            "</div>" +
            "<div class='is-centered'>" +
            "<figure class='image'>" +
            "<img id='listImagePreview-" + itemId + "' src='" + pic + "'>" +
            "</figure>" +
            "<br/>"+
            "<label class='label' >Bild Url:</label>" +
            "<a href=\"" + pic + "\" target=\"_blank\">" +
            "<label style=\"cursor: pointer\">" + pic + "</label>" +
            "</a>" +
            "</div>" +
            "</div>" +
            "</div>";

        $(`#${this.divElementId}`).append(itemElement);

        $(`#listImageInput-${itemId}`).change(() => {
            console.log("LIST IMAGE CHANGED");
            this.readUrl($(`#listImageInput-${itemId}`)[0], `listImagePreview-${itemId}`, `listImageLabel-${itemId}`);
        });
        
        $(`#picUploadFieldRemove-${itemId}`).click(() => {
            this.itemList.splice(itemId, 1);
            this.redrawItems();
        });
    }

    protected addNewItem() {
        const defaultFileAsset: FileAssetDto = {
            Filename: "",
            ImageId: this.emptyGuidString,
            ImageChanged: null
        };

        this.itemList.push(defaultFileAsset);
        console.log(this.itemList);
    }

    // See https://stackoverflow.com/questions/4459379/preview-an-image-before-it-is-uploaded
    protected readUrl(input, previewId, labelId) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (e !== null && e.target !== null) {
                    $("#" + previewId).prop("src", e.target.result);
                }
            }

            // Set input label
            reader.readAsDataURL(input.files[0]); // convert to base64 string
            $("#" + labelId).val(input.files[0].name);
        }
    }

    // Returns a date as string in the format yyyy-MM-ddThh:mm
    protected getDateTimeString(date: Date) {
        // For some strange reason, the parameter date can not be used directly ...
        // Therefore, another variable must be initialized
        const sameDate = new Date(date);
        return (`${sameDate.getFullYear().toString()}-${(`0${sameDate.getMonth() + 1}`).slice(-2)}-${(`0${sameDate.getDate()}`).slice(-2)}T${(`0${sameDate.getHours()}`).slice(-2)}:${(`0${sameDate.getMinutes()}`).slice(-2)}`)
    }
}